var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-layout',{attrs:{"row":""}},_vm._l((_vm.list),function(item){return _c('v-flex',{key:item.field,staticClass:"pb-0",attrs:{"xs3":""}},[_c('v-text-field',{attrs:{"label":item.label,"value":_vm.data[item.field],"hide-details":""},on:{"change":function($event){return _vm.$emit('change', { field: item.field, event: $event })}}})],1)}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }